import { Routes } from '@angular/router';
import { MatidorAdminResolve } from './matidor-admin.resolve';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'workspaces',
    pathMatch: 'full'
  },
  {
    path: '',
    resolve: [MatidorAdminResolve],
    loadComponent: () => import('./matidor-admin/matidor-admin.component').then((m) => m.MatidorAdminComponent),
    children: [
      {
        path: 'users',
        loadComponent: () => import('./matidor-admin/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'workspaces',
        loadComponent: () => import('./matidor-admin/workspaces/workspaces.component').then((m) => m.WorkspacesComponent),
      },
      {
        path: 'api-keys',
        loadComponent: () => import('./matidor-admin/api-keys/api-keys.component').then((m) => m.ApiKeysComponent),
      },
      {
        path: 'ai-settings',
        loadComponent: () => import('./matidor-admin/ai-settings/ai-settings.component').then((m) => m.AiSettingsComponent),
      },
      {
        path: 'ai-history',
        loadComponent: () => import('./matidor-admin/ai-history/ai-history.component').then((m) => m.AiHistoryComponent),
      },
      {
        path: 'ai-history/conversations/:id',
        loadComponent: () => import('./matidor-admin/ai-history/transcript/ai-transcript.component').then((m) => m.AiTranscriptComponent),
      },
      {
        path: 'integrations',
        loadComponent: () => import('./matidor-admin/integrations/integrations.component').then((m) => m.IntegrationsComponent),
      },
      {
        path: 'integrations/arcgis/:workspaceKey',
        loadComponent: () => import('./matidor-admin/integrations/arcgis-integration/arcgis-integration.component').then((m) => m.ArcgisIntegrationComponent),
      },
      {
        path: 'offline',
        loadComponent: () => import('./matidor-admin/offline/offline.component').then((m) => m.OfflineComponent),
      },
      {
        path: 'onboarding',
        loadComponent: () => import('./matidor-admin/onboarding/onboarding.component').then((m) => m.OnboardingComponent),
      }
    ]
  },
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
];
